import Parametros from 'Interface/Requisicao';
import Treinamento, {
  FinderTreinamentos,
  RetornoTreinamento,
} from 'Interface/Treinamentos';
import api from 'Service';

import { formData, paramsParaString } from '../utils';

const tag = 'Treinamentos';

const url = '/treinamentos';

const apiExtendida = api
  .enhanceEndpoints({
    addTagTypes: [tag],
  })
  .injectEndpoints({
    endpoints: (construtor) => ({
      recuperarTreinamentos: construtor.query<
        FinderTreinamentos,
        Parametros | void
      >({
        query: (params) => `${url}?${paramsParaString(params)}`,
        providesTags: (resultado) =>
          resultado?.treinamentos
            ? [
                ...resultado.treinamentos.map(
                  ({ id }) => ({ type: tag, id } as const)
                ),
                { type: tag, id: 'LISTA' },
              ]
            : [{ type: tag, id: 'LISTA' }],
      }),
      recuperarTreinamento: construtor.query<
        RetornoTreinamento,
        string | number | Parametros
      >({
        query: (params) => {
          let id: number;
          let query: Parametros = {};

          if (['string', 'number'].includes(typeof params)) {
            id = params as number;
          } else {
            params = params as Parametros;

            id = params.id as number;
            query = paramsParaString(params);
          }

          return `${url}/${id}?${query}`;
        },
        providesTags: (resultado, erro, params) => {
          let id: number;

          if (['string', 'number'].includes(typeof params)) {
            id = params as number;
          } else {
            params = params as Parametros;

            id = params.id as number;
          }

          return [{ type: tag, id }];
        },
      }),
      adicionarTreinamento: construtor.mutation<
        RetornoTreinamento,
        Partial<Treinamento>
      >({
        query: (dados) => ({
          url: url,
          method: 'POST',
          body: dados,
        }),
        invalidatesTags: (resultado, erro) =>
          !erro ? [{ type: tag, id: 'LISTA' }] : [],
      }),
      editarTreinamento: construtor.mutation<
        RetornoTreinamento,
        Partial<Treinamento> &
          Pick<Treinamento, 'id'> & { options?: Parametros }
      >({
        query: ({ id, options, ...dados }) => ({
          url: `${url}/${id}?${paramsParaString({ options })}`,
          method: 'POST',
          body: formData(dados, 'PUT'),
        }),
        invalidatesTags: (resultado, erro, { id }) =>
          !erro ? [{ type: tag, id }] : [],
      }),
      removerTreinamento: construtor.mutation<
        Treinamento,
        Partial<Treinamento> & Pick<Treinamento, 'id'>
      >({
        query: ({ id, ...dados }) => ({
          url: `${url}/${id}`,
          method: 'POST',
          body: formData(dados, 'DELETE'),
        }),
        invalidatesTags: (resultado, erro, { id }) =>
          !erro ? [{ type: tag, id }] : [],
      }),
    }),
    overrideExisting: false,
  });

export const {
  useRecuperarTreinamentosQuery,
  useRecuperarTreinamentoQuery,
  useAdicionarTreinamentoMutation,
  useEditarTreinamentoMutation,
  useRemoverTreinamentoMutation,
} = apiExtendida;
